import Header from "../../../sharedScreens/Header";
import SideMenu from "../../../sharedScreens/menuItems/SideMenu";
import React from "react";
import MuiSearchSelect from "../../../components/basicComponent/MuiSearchSelect";
import MuiButton from "../../../components/basicComponent/MuiButton";
import MuiDatePicker from "../../../components/basicComponent/MuiDatePicker";

const MarkupDetails = () => {
  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header text-center">
              <h3 className="card-title">Service Fee/Markup Details</h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-custom">
                  <div className="card-body">
                    <div className="row mt-4">
                      <div className="col-md-4">
                        <MuiSearchSelect
                          label={"Customer Name"}
                          placeholder="Customer Name"
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>

                      <div className="col-md-4">
                        <MuiDatePicker
                          value={null}
                          onChange={function (date: string): void {
                            throw new Error("Function not implemented.");
                          }}
                        />
                      </div>
                      <div className="col-md-4">
                      <MuiDatePicker
                          value={null}
                          onChange={function (date: string): void {
                            throw new Error("Function not implemented.");
                          }}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiSearchSelect
                          label={"S PNR "}
                          placeholder="S PNR"
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiSearchSelect
                          label={"Type"}
                          placeholder="Type"
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "10px",
                          marginTop: "8px",
                        }}
                      >
                        <div className="user-button w-full">
                          <MuiButton
                            className="clear-btn "
                            label="Clear"
                            type="submit"
                          />
                          <MuiButton
                            label={"Get"}
                            className="main-btn get-btn"
                            variant="contained"
                            size="large"
                            type="submit"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default MarkupDetails;
